var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallBackgroundBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "small-background-blob",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 412 915",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "753e3f61067240a68205622f93b0bf7b",
    "export-id": "29e2bda6f57a4f88bdd4e5acdf6dff64",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "small-background-blob-s-path1",
    d: "M412,111.721556C203.248073,184.5721,15.504332,315.947736,81.472684,458.438863C202.541652,579.821028,340.300779,525.956685,412,490.584839v-378.863283Z",
    transform: "translate(0-111.721556)",
    fill: "#fec828",
    fillOpacity: 0.2,
    stroke: "#3f5787",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBackgroundBlob);
export default __webpack_public_path__ + "static/media/small-background-blob.df119fd65e8a5c737072b4e110d6618a.svg";
export { ForwardRef as ReactComponent };